<script>
import axios from 'axios';

export default {

    props: {
        bulkImportConfig: {
            required: true,
            type: Object
        },
        projectId: {
            required: false,
            type: Number,
            default: null
        },
        phaseId: {
            required: false,
            type: Number,
            default: null
        },
        isLocked: {
            type: Boolean,
            default: false
        },
        metaType: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            queueLogsRefresh: false,
            isSaving: false
        }
    },
    created() {
        if(!this.bulkImportForm) {
            this.$store.dispatch('form_configurations/getFormConfiguration', this.bulkImportConfig?.bulk_import_form_configuration);
        }
    },
    computed: {
        bulkImportForm() {
            return this.$store.getters['form_configurations/getFormConfigurationByName'](this.bulkImportConfig?.bulk_import_form_configuration);
        },
        programTrack() {
            return this.$store.getters.getProgramTrackForName(this.bulkImportConfig?.program_track);
        },
        programYear() {
            return this.$store.getters.getProgramYearForName(this.bulkImportConfig?.program_year);
        },
        instructionText() {
            return this.bulkImportConfig?.instruction_text;
        },
        canBypassBulkImport() {
            if(!this.bulkImportConfig?.bypass_bulk_import_ability) {
                return false;
            }

            return window.MAT.permissions.filter(permission => {
                return permission.name === this.bulkImportConfig?.bypass_bulk_import_ability;
            }).length > 0;
        },
        bypassBulkImportBtnText() {
            return this.bulkImportConfig?.bypass_bulk_import_button_text ?? 'Create Blank Project';
        },
        formActions() {
            return [
                {
                    name: 'setup_import',
                    label: this.bulkImportConfig?.bulk_import_import_button_text ?? 'Setup Import',
                    action: 'setup-import'
                }
            ];
        }
    },
    methods: {
        async refreshQueueLogs() {
            setTimeout(() => {
                this.queueLogsRefresh = true

                // Possible Inclusion but worth discussion.
                //
                // if(window.Bus) {
                //     window.Bus.$emit('updateProjectImportHistory', this.metaType)
                // }
            }, 2000);
        },
        handleCreateBlankProject() {
            if(
                !this.canBypassBulkImport ||
                !this.programTrack?.id ||
                !this.programYear?.id
            ) {
                window.notify.error("You do not have permission to create blank project.");
                return;
            }

            window.location = '/project/create?program_track_id=' + this.programTrack.id + '&program_year_id=' + this.programYear.id;
        },
        handleBulkImport(data) {
            this.isSaving = true;

            axios.post('/api/projects/bulk_import', data)
            .then((response) => {
                window.notify.success("Import setup successfully. Please check your email for when it completes.");
            }).catch((error) => {
                window.notify.apiError(error);
            }).finally(() => {
                this.isSaving = false;
            });
        }
    }
}
</script>
<template>
    <div>
        <div class="p-4">
            <div class="flex border-b">
                <div class="w-1/2 flex">
                    <div class="form-group w-1/2 ">
                        <label class="form-control-label font-bold"><span>Program Track</span></label>
                        <span class="block">{{ this.programTrack?.title }}</span>
                    </div>
                    <div class="form-group w-1/2 ">
                        <label class="form-control-label font-bold"><span>Program Year</span></label>
                        <span class="block">{{ this.programYear?.program_year }}</span>
                    </div>
                </div>
                <div
                    v-if="!this.projectId && this.programTrack?.id && this.programYear?.id && canBypassBulkImport"
                    class="ml-12 w-1/2 text-right"
                >
                    <button
                        @click="handleCreateBlankProject"
                        class="inputbutton1"
                        v-html="bypassBulkImportBtnText"
                    ></button>
                </div>
            </div>
            <div
                v-if="instructionText"
                class="py-4"
            >
                <span v-html="instructionText"></span>
            </div>
            <vue-form
                v-if="bulkImportForm"
                class="py-4 w-1/2 mx-auto"
                :form-config="bulkImportForm"
                :form-data="{
                    programTrackId: programTrack?.id,
                    programYearId: programYear?.id,
                    projectId: projectId,
                    phaseId: phaseId,
                    metaType: metaType
                }"
                :auto-save="false"
                :is-saving="isSaving"
                :actions="formActions"
                :disabled="isLocked"
                @setup-import="handleBulkImport"
                @created="refreshQueueLogs"
            ></vue-form>
        </div>
    </div>
</template>
